import React from 'react';

import RegisterForm from './components/RegisterForm';

const Register = () => {
  return (
    <div
      className="min-h-screen flex"
      style={{ background: 'var(--color-background)' }}
    >
      {/* Left Panel - Branding (hidden on mobile) */}
      <div
        className="hidden lg:flex lg:w-5/12 xl:w-1/2 flex-col justify-between p-12 relative overflow-hidden"
        style={{ background: 'var(--color-card)', borderRight: '2px solid var(--color-border)' }}
      >
        {/* Geometric Accents */}
        <div style={{ position: 'absolute', top: '-60px', right: '-60px', width: '280px', height: '280px', border: '2px solid rgba(255, 87, 34, 0.12)', borderRadius: '2px', transform: 'rotate(20deg)' }} />
        <div style={{ position: 'absolute', bottom: '80px', left: '-50px', width: '220px', height: '220px', border: '2px solid rgba(0, 79, 152, 0.1)', borderRadius: '2px', transform: 'rotate(-12deg)' }} />
        <div style={{ position: 'absolute', top: '40%', right: '10%', width: '100px', height: '100px', border: '1px solid rgba(255, 87, 34, 0.08)', borderRadius: '2px', transform: 'rotate(5deg)' }} />

        {/* Logo */}
        <div className="flex items-center gap-3 relative z-10">
          <div style={{ width: '44px', height: '44px', background: 'var(--color-primary)', borderRadius: 'var(--radius-sm)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '18px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.04em' }}>
            Veiassistent
          </span>
        </div>

        {/* Main Content */}
        <div className="relative z-10">
          <div style={{ display: 'inline-block', background: 'var(--color-primary)', padding: '4px 12px', marginBottom: '20px', borderRadius: 'var(--radius-sm)' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FFFFFF' }}>
              Ny konto
            </span>
          </div>

          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '32px', fontWeight: 700, lineHeight: 1.2, letterSpacing: '0.02em', color: 'var(--color-foreground)', marginBottom: '16px' }}>
            Kom i gang
            <br />
            <span style={{ color: 'var(--color-accent)' }}>gratis i dag</span>
          </h1>

          <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 400, lineHeight: 1.6, color: 'var(--color-muted-foreground)', maxWidth: '340px' }}>
            Opprett din konto og få tilgang til alle funksjoner for intelligent veiplanlegging i Norge.
          </p>

          {/* Benefits */}
          <div style={{ marginTop: '32px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { title: 'Gratis å starte', desc: 'Ingen kredittkort nødvendig' },
              { title: 'Sanntidsdata', desc: 'Oppdatert trafikkinfo' },
              { title: 'Sikker lagring', desc: 'Dine data er beskyttet' },
            ]?.map((item) => (
              <div key={item?.title} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ width: '20px', height: '20px', background: 'rgba(255, 87, 34, 0.15)', border: '1px solid rgba(255, 87, 34, 0.3)', borderRadius: 'var(--radius-sm)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M2 5l2.5 2.5L8 3" stroke="#FF5722" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div>
                  <p style={{ fontFamily: 'var(--font-caption)', fontSize: '13px', fontWeight: 500, color: 'var(--color-foreground)', marginBottom: '2px', letterSpacing: '0.01em' }}>
                    {item?.title}
                  </p>
                  <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', fontWeight: 400, color: 'var(--color-muted-foreground)', letterSpacing: '0.01em' }}>
                    {item?.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="relative z-10">
          <p style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', fontWeight: 400, color: 'rgba(156, 163, 175, 0.5)', letterSpacing: '0.02em' }}>
            © 2024 Veiassistent AS · Alle rettigheter forbeholdt
          </p>
        </div>
      </div>
      {/* Right Panel - Register Form */}
      <div className="flex-1 flex flex-col justify-center items-center px-6 sm:px-12 lg:px-16 py-12">
        {/* Mobile Logo */}
        <div className="lg:hidden flex items-center gap-3 mb-8">
          <div style={{ width: '40px', height: '40px', background: 'var(--color-primary)', borderRadius: 'var(--radius-sm)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '18px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.04em' }}>
            Veiassistent
          </span>
        </div>

        <div style={{ width: '100%', maxWidth: '420px' }}>
          {/* Form Header */}
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '28px', fontWeight: 700, lineHeight: 1.2, letterSpacing: '0.02em', color: 'var(--color-foreground)', marginBottom: '10px' }}>
              Opprett konto
            </h2>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 500, lineHeight: 1.5, color: 'var(--color-muted-foreground)' }}>
              Fyll ut skjemaet for å komme i gang
            </p>
          </div>

          {/* Section Label */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <div style={{ height: '2px', flex: 1, background: 'var(--color-border)' }} />
            <span style={{ fontFamily: 'var(--font-caption)', fontSize: '11px', fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-muted-foreground)', whiteSpace: 'nowrap' }}>
              Kontoinformasjon
            </span>
            <div style={{ height: '2px', flex: 1, background: 'var(--color-border)' }} />
          </div>

          <RegisterForm />
        </div>
      </div>
    </div>
  );
};

export default Register;
